var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerishable3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5833 29.1667V25L22.9167 14.5833V3.125C22.9167 1.39583 21.5208 0 19.7917 0C18.0625 0 16.6667 1.39583 16.6667 3.125V14.5833L0 25V29.1667L16.6667 23.9583V35.4167L12.5 38.5417V41.6667L19.7917 39.5833L27.0833 41.6667V38.5417L22.9167 35.4167V23.9583L39.5833 29.1667Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerishable3);
export default __webpack_public_path__ + "static/media/perishable3.cc7dc0777fb07fc1fffcabf31a22aa2c.svg";
export { ForwardRef as ReactComponent };